// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_44-2";
export var blackBorderOnHover = "_44-7";
export var cell = "_44-6";
export var cellContainer = "_44-3";
export var checked = "_44-8";
export var disabled = "_44-5";
export var featuredIconCellContainer = "_44-9";
export var featuredIconTextContainer = "_44-b";
export var featuredIconWrapper = "_44-a";
export var noBorder = "_44-c";
export var orangeSelectedRow = "_ar-3";
export var overflowableText = "_44-0";
export var overflowableTextContainer = "_44-1";
export var row = "_48-0";
export var rowCheckboxCell = "_44-4";
export var selectableTable = "_ar-2";